import * as React from 'react'
import { IconButton } from '../IconButton'

export interface InfoSectionItemProps {
    onClick?: () => void
    title: JSX.Element
    subtitle?: string
}

export function InfoSectionItem(props: InfoSectionItemProps) {
    return (
        <div className="AppCore__ui__UserProfile__Item">
            <div className="AppCore__ui__UserProfile__Item-content">
                <div className="AppCore__ui__UserProfile-title">{props.title}</div>
                {props.subtitle && <div className="AppCore__ui__UserProfile__Item-Subtitle">{props.subtitle}</div>}
            </div>
            {props.onClick && (
                <div className="AppCore__ui__UserProfile__Item-actions">
                    <IconButton border={false} iconName="ellipsis" onClick={props.onClick} size="small" />
                </div>
            )}
        </div>
    )
}
